export default {
      id: "i-yandex-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "img/sprite.svg#i-yandex",
      toString: function () {
        return this.url;
      }
    }